export default __webpack_public_path__ + "static/logo-vertical-84edb66bcbdef969387c68b5eb4428db.jpg";